import { useState, useEffect } from "react";
import {
  Frame,
  Loading,
  Header,
  Input,
  Select,
  ValidaUid,
} from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm3 } from "../components/Validacao";
import { db, auth } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Row, Col } from "react-bootstrap";

const Form3 = () => {
  const [dados, setDados] = useState({});

  const [erro, setErro] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    let novoValor = value;

    //SOMENTE NUMEROS
    if (["cep"].includes(name)) {
      novoValor = value.replace(/\D/g, "");
    }

    setDados((prev) => ({
      ...prev,
      [name]: novoValor.toUpperCase(),
    }));
  };

  const setData = async () => {
    await setDoc(doc(db, "furg2026", uid), { ...dados }, { merge: true });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const err = ValidaForm3(dados);

    if (err) {
      setErro(err);
      setLoading(false);
    } else {
      setData().then(() => navigate("../form4"));
    }
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "furg2026", uid));

      const data = qry.data();

      const contrato = data?.contrato;

      if (contrato !== "2026") setLoading(false);
      else navigate("../home");
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      {!loading && (
        <Frame
          body={
            <form
              className="text-start"
              autoComplete="off"
              onSubmit={handleSubmit}
              noValidate
            >
              <Row>
                <Col className="mt-3" sm="3">
                  <Select
                    id="logradouro3"
                    label="Logradouro"
                    onChange={handleChange}
                    size="col-sm-4"
                    value={dados?.logradouro3}
                    erro={erro.logradouro3}
                    options={
                      <>
                        <option value="">Selecione</option>
                        <option value="RUA">Rua</option>
                        <option value="AVENIDA">Avenida</option>
                        <option value="TRAVESSA">Travessa</option>
                        <option value="PRAÇA">Praça</option>
                        <option value="PARQUE">Parque</option>
                        <option value="CONDOMÍNIO">Condomínio</option>
                        <option value="ALAMEDA">Alameda</option>
                        <option value="ESTRADA">Estrada</option>
                        <option value="BECO">Beco</option>
                        <option value="VIELA">Viela</option>
                        <option value="LARGO">Largo</option>
                      </>
                    }
                  />
                </Col>
                <Col className="mt-3" sm="9">
                  <Input
                    id="endereco3"
                    label="Endereço"
                    type="text"
                    className={erro.endereco3 && "is-invalid"}
                    placeholder="Digite seu endereço"
                    value={dados?.endereco3}
                    onChange={handleChange}
                    erro={erro.endereco3}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-3" sm="3">
                  <Input
                    id="numero3"
                    label="Número"
                    type="text"
                    className={erro.numero3 && "is-invalid"}
                    placeholder="9999"
                    value={dados?.numero3}
                    onChange={handleChange}
                    erro={erro.numero3}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="bairro3"
                    label="Bairro"
                    type="text"
                    className={erro.bairro3 && "is-invalid"}
                    placeholder="Digite seu bairro"
                    value={dados?.bairro3}
                    onChange={handleChange}
                    erro={erro.bairro3}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="cidade3"
                    label="Cidade"
                    type="text"
                    className={erro.cidade3 && "is-invalid"}
                    placeholder="Digite sua cidade"
                    value={dados?.cidade3}
                    onChange={handleChange}
                    erro={erro.cidade3}
                  />
                </Col>
                <Col className="mt-3" sm="3">
                  <Input
                    id="cep3"
                    label="CEP"
                    type="number"
                    className={erro.cep3 && "is-invalid"}
                    placeholder="Digite seu CEP"
                    value={dados?.cep3}
                    onChange={handleChange}
                    erro={erro.cep3}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="mt-3">
                  <Input
                    id="complemento3"
                    label="Complemento"
                    type="number"
                    className={erro.complemento3 && "is-invalid"}
                    placeholder="Opcional"
                    value={dados?.complemento3}
                    onChange={handleChange}
                    erro={erro.complemento3}
                  />
                </Col>
              </Row>

              <Row>
                <Col className="mt-4 d-grid" sm="12">
                  <button type="submit" className="btn btn-primary">
                    PRÓXIMO
                  </button>
                </Col>
              </Row>
            </form>
          }
          title="Local de Desembarque"
        />
      )}
    </>
  );
};

export default Form3;
